import React, { useContext } from "react";
import { FacilityID, Role } from "../../constants/defaultKeys";
import { UserContext } from "../../context/UserContext";
import { getCookie } from "../../helpers/localStorage";
import { PatientTypeContext } from "../Layout/DoctorLayout/PatientTypeContextProvider";
import NoDataPage from "../NoDataPages/NoDataPage";
import InPatientsCard from "./InPatientsCard";
import OutPatientsCard from "./OutPatientsCard";
import PatientDataIcon from "../../assets/images/nurseIcons/patientdata.svg";

const PatientCards = () => {
  const { userDetails } = useContext(UserContext);
  const defaultRole = userDetails?.currRole || getCookie(Role);
  const defaultFacility = userDetails?.currFacility || getCookie(FacilityID);

  const role = defaultRole.toLowerCase().replaceAll("_", "-");

  const { patientType } = useContext(PatientTypeContext);

  const activeRoleObj = userDetails?.activeOrg?.roles?.find(
    (r) => r.role === defaultRole && r.facility_id === Number(defaultFacility)
  );

  const { ip_available, op_available } = activeRoleObj || {};

  // 🔥 CASE 1: Requested view is InPatients but IP is not available
  if (patientType === "inPatients" && !ip_available) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          width: "100%",
          padding: "20px",
          color: "#999",
        }}
      >
        <NoDataPage
          title="No Patients Available"
          subtitle="Please check back later or adjust your filters."
          image={PatientDataIcon}
        />
      </div>
    );
  }

  // 🔥 CASE 2: Requested OutPatients but OP is not available
  if (patientType === "outPatients" && !op_available) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          width: "100%",
          padding: "20px",
          color: "#999",
        }}
      >
        <NoDataPage
          title="No Patients Available"
          subtitle="Please check back later or adjust your filters."
          image={PatientDataIcon}
        />
      </div>
    );
  }

  // If data is available, show correct card
  return patientType === "outPatients" ? (
    <OutPatientsCard userDetails={userDetails} role={role} />
  ) : (
    <InPatientsCard userDetails={userDetails} role={role} />
  );
};

export default PatientCards;
